/**
 * CO 523 — the homepage hero copy, single source.
 *
 * Consumed by BOTH `HomePage.tsx` (the rendered hero) and
 * `scripts/generate-portal-index.ts` (the crawler-visible static shell in
 * `portal-app/index.html`). One copy of the copy: editing here changes both
 * surfaces; editing either surface directly is the CO 293 dual-copy trap and
 * the verify-time `--check` will catch the shell side.
 *
 * Frame (Ron 2026-09-06): the portal's purpose is growing the network by node
 * installs — FofF in the hero, /install leads.
 */

export const HERO_EYEBROW = 'The operating system you run your business on';

export const HERO_H1_LINE_1 = 'Your business. Its own world.';
/** Line 2 renders with a highlight span around HERO_H1_HIGHLIGHT. */
export const HERO_H1_LINE_2_PRE = 'On a machine ';
export const HERO_H1_HIGHLIGHT = 'you own';
export const HERO_H1_LINE_2_POST = '.';
export const HERO_H1_LINE_2 = `${HERO_H1_LINE_2_PRE}${HERO_H1_HIGHLIGHT}${HERO_H1_LINE_2_POST}`;

export const HERO_LEAD =
  'ComOS is a federation of federations: every business on it runs a complete world — its catalog, ' +
  'its customers, its agents — and the network holds one economy: one mint, one ledger, one ' +
  'settlement rail. Install your world on a machine on your desk. Or start free in our cloud and ' +
  "move home whenever you're ready.";

export const HERO_CTA_INSTALL = 'Install ComOS on your own machine';
export const HERO_CTA_START = 'Start free in the cloud';

export const HERO_TRUST_LINE = 'Free to join · pay only when money moves · no inbound ports, ever';
